import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    width: ${props => `${props.width}px`};
    background-color: var(--primary-color);
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    margin: 0.5rem 0;
    padding: 0.5rem;
    border: 1px solid var(--primary-accent-color);
`

const Options = props => {
    const {
        blocks,
        closeHandler,
        width
    } = props;
    
    let updatedBlocks = blocks.map(block => (React.cloneElement(block, {closeHandler: closeHandler})))
    return (
        <Container width={width}>{updatedBlocks}</Container>
    )
}

export default Options